var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-touch',{staticClass:"wrapper",on:{"swiperight":_vm.swiperright}},[_c('div',{staticClass:"attachmentPreview"},[(_vm.isNews != true)?_c('van-nav-bar',{attrs:{"title":"附件预览","left-text":"审批办理","left-arrow":""},on:{"click-left":_vm.onClickLeft}}):_vm._e(),_c('section',[_c('iframe',{attrs:{"src":_vm.src,"frameborder":"0"}})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }